export default "__VITE_ASSET__COvXHqGm__"